
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();


const  getParam = ( sysParams, paramID ) => {
  let v = sysParams && sysParams.find( par => par.param_id === paramID );
  return v && v.param_value ;
}



var numeral = require('numeral');

numeral.register('locale', 'ar', {
  delimiters: {
      thousands: '.',
      decimal: ','
  },
  abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
  },
  ordinal : function (number) {
      return number === 1 ? 'er' : 'do';
  },
  currency: {
      symbol: '$'
  }
});

numeral.locale('ar');
// numeral.locale('ar');

const capitalize = (str) =>  { 
    str = str.trim();
    var ret = str.split(" ").map( (val) => {
      val = val.trim();
      if (val) return val[0].toUpperCase() + val.slice(1).toLowerCase(); else return '';
    })
    return ret.join(' ') ;
  } 


/**
 * Compare 2 dates. 
 * @param {*} day 
 * @param {*} comparesTo 
 * @param {*} what Include D, M or Y to include them in the comparision
 */
  const compareDates = ( day, comparesTo, what = null )=>  {
if (what === null)
    return (day.getDate() === comparesTo.getDate() && 
            day.getMonth() === comparesTo.getMonth() && 
            day.getFullYear() === comparesTo.getFullYear() ) ;
  else

    return (
      ( what.indexOf('D')===-1 || day.getDate() === comparesTo.getDate() ) && 
      ( what.indexOf('M')===-1 || day.getMonth() === comparesTo.getMonth() ) && 
      ( what.indexOf('Y')===-1 || day.getFullYear() === comparesTo.getFullYear() ) ) 

}




const fmtNumber = (number, format ) => {
  return numeral(number).format(format);
}

const fmtPhone = (phone) => {
  if (!phone) return '-' ;
  let dev = '';
  try {
    dev = phoneUtil.formatInOriginalFormat(phoneUtil.parseAndKeepRawInput(phone, 'AR')) ;
  } catch (err) {
    dev = phone ;
  }

  return dev ;
}

const defaultCover = () => {
  let id = 1; 
  // if (val != null) {
  //   if ((val.toUpperCase).substring(0,1) < 'E') id = 1;
  //   else if ((val.toUpperCase).substring(0,1) > 'P') id = 2;
  //   }
 
  return "https://alumni-images.s3.us-east-2.amazonaws.com/subjects/covers/default-cover-"+ id + ".jpg";
}






export { capitalize, compareDates, fmtPhone, fmtNumber, defaultCover, getParam}